class DLPageTradeInH extends HTMLElement {
    constructor() {
        super();
        this.Max_Size_MB = 0.2;
        this.Min_Quality = 0.1;
        this.Scale_Step = 0.9;
        this.Quality_Step = 0.1;
        this.imgbbApiKey = '7c8022492edf8ccd60fa7eae8f2f959f';
    }

    connectedCallback() {
        this.main = this.querySelector('.dl-page-trade-in-h');
        this.field_items = this.querySelectorAll('.dl-page-trade-in-h-body-form-item');
        this.submit_btn = this.querySelector('.dl-page-trade-in-h-body-form-footer-btn');
        this.bindEvents();
        this.bindTabEvents();

        this.init();
    }

    bindEvents() {
        this.field_items.forEach((item) => {
            switch (item.dataset.dlType) {
                case 'image':
                    let input_file = item.querySelector('input[type="file"]');
                    input_file.addEventListener('change', (e) => {
                        let file = e.target.files[0];
                        if (file) {
                            const preview_img = document.createElement('img');
                            preview_img.src = URL.createObjectURL(file);
                            item.classList.add('dl-uploading');
                            item.querySelector('.dl-page-trade-in-h-body-form-item-value-image-upload-main').innerHTML = '';
                            item.querySelector('.dl-page-trade-in-h-body-form-item-value-image-upload-main').appendChild(preview_img);

                            let progress = 0;
                            let progress_bar = item.querySelector('.dl-page-trade-in-h-body-form-item-value-image-uploading-icon');
                            let progress_max = 95;

                            let interval = setInterval(() => {
                                updateProcess(interval);
                            }, 15);

                            let updateProcess = (interval) => {
                                if (progress < progress_max) {
                                    progress++;
                                    progress_bar.style.background = `conic-gradient(#315800 ${progress}%, #f7f7f7 ${progress}%)`;
                                } else {
                                    if (progress_max == 100) {
                                        item.classList.remove('dl-uploading');
                                        item.classList.add('dl-upload');
                                        this.resetItemError(item);
                                        clearInterval(interval);
                                    }
                                }
                            }

                            this.adjustImageSize(file)
                                .then((blob) => {
                                    this.uploadToImgBB(blob)
                                        .then((url) => {
                                            item.dataset.dlValue = url;
                                            progress_max = 100;
                                        })
                                        .catch((error) => {
                                            console.error(error);
                                        });
                                })
                                .catch((error) => {
                                    console.error(error);
                                });
                        }
                    });

                    let remove_btn = item.querySelector('.dl-page-trade-in-h-body-form-item-value-image-upload-delete');
                    if (remove_btn) {
                        remove_btn.addEventListener('click', (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            item.querySelector('.dl-page-trade-in-h-body-form-item-value-image-upload-main').innerHTML = '';
                            item.dataset.dlValue = '';
                            item.classList.remove('dl-upload');
                        });
                    }
                    break;
                case 'email':
                case 'input':
                    let input_field = item.querySelector('.dl-page-trade-in-h-body-form-item-value-input');
                    input_field.addEventListener('input', (e) => {
                        this.resetItemError(item);
                    });
                    break;
                case 'select':
                    let select_main = item.querySelector('.dl-page-trade-in-h-body-form-item-value-select-main');
                    select_main.addEventListener('change', (e) => {
                        this.resetItemError(item);
                    });
                    let other_textarea = item.querySelector('textarea');
                    if (other_textarea) {
                        other_textarea.addEventListener('input', (e) => {
                            this.resetItemError(item);
                        });
                    }
                    break;
            }
        });

        this.submit_btn.addEventListener('click', (e) => {
            this.formSubmit();
        });
    }


    bindTabEvents() {
        const tabs = this.querySelectorAll('.dl-page-trade-in-h-tab');
        const panels = this.querySelectorAll('.dl-page-trade-in-h-panel');
        const greenLine = this.querySelector('.dl-page-trade-in-h-tabs-line-green');
    
        if (tabs.length === 0 || panels.length === 0) return;
    
        // 更新绿色线条位置和宽度的函数
        const updateGreenLine = (tab) => {
            if (!greenLine || !tab) return;
            
            const tabText = tab.querySelector('.dl-page-trade-in-h-tab-text');
            if (!tabText) return;
    
            // 获取 tab 相对于父容器 tabs-line 的位置
            const tabsLine = this.querySelector('.dl-page-trade-in-h-tabs-line');
            const tabsContainer = this.querySelector('.dl-page-trade-in-h-tabs');
            
            if (!tabsLine || !tabsContainer) return;
    
            // 计算 tab 文字相对于 tabs-line 的位置
            const tabRect = tab.getBoundingClientRect();
            const tabTextRect = tabText.getBoundingClientRect();
            const containerRect = tabsContainer.getBoundingClientRect();
    
            // 计算绿色线条应该的 left 位置（相对于 tabs-line）
            const lineLeft = tabTextRect.left - containerRect.left;
            const lineWidth = tabTextRect.width;
    
            greenLine.style.left = `${lineLeft}px`;
            greenLine.style.width = `${lineWidth}px`;
        };
    
        // 切换选项卡的函数
        const switchTab = (tab) => {
            const targetIndex = tab.dataset.tabIndex;
    
            // 移除所有激活状态（操作 tab-text）
            this.querySelectorAll('.dl-page-trade-in-h-tab-text').forEach((t) => 
                t.classList.remove('dl-page-trade-in-h-tab-active')
            );
            panels.forEach((p) => p.classList.remove('dl-page-trade-in-h-panel-active'));

            // 激活当前选项卡的文本（操作 tab-text）
            const tabText = tab.querySelector('.dl-page-trade-in-h-tab-text');
            if (tabText) {
                tabText.classList.add('dl-page-trade-in-h-tab-active');
            }

            // 激活对应内容面板
            const targetPanel = this.querySelector(`.dl-page-trade-in-h-panel[data-panel-index="${targetIndex}"]`);
            if (targetPanel) {
                targetPanel.classList.add('dl-page-trade-in-h-panel-active');
            }
    
            // 更新绿色线条
            updateGreenLine(tab);
        };
    
        // 绑定点击事件
        tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                switchTab(tab);
            });
        });
    
        // 初始化：激活第一个选项卡的绿色线条
        const activeTab = this.querySelector('.dl-page-trade-in-h-tab-active');
        if (activeTab) {
            // 使用 requestAnimationFrame 确保 DOM 渲染完成后再计算位置
            requestAnimationFrame(() => {
                updateGreenLine(activeTab);
            });
        }
    
        // 窗口大小变化时重新计算绿色线条位置
        window.addEventListener('resize', () => {
            const currentActiveTab = this.querySelector('.dl-page-trade-in-h-tab-active');
            if (currentActiveTab) {
                updateGreenLine(currentActiveTab);
            }
        });
    }

    adjustImageSize(image_file) {
        return new Promise((resolve, reject) => {
            let finalBlob = null;
            const MAX_DIMENSION = 800;

            if (image_file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const img = new Image();
                    img.src = e.target.result;
                    img.onload = () => {
                        let canvas = document.createElement('canvas');
                        let ctx = canvas.getContext('2d');

                        let width = img.width;
                        let height = img.height;

                        if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
                            const scale = Math.min(MAX_DIMENSION / width, MAX_DIMENSION / height);
                            width = Math.round(width * scale);
                            height = Math.round(height * scale);
                        }

                        canvas.width = width;
                        canvas.height = height;

                        let quality = 1;

                        const resizeImage = () => {
                            ctx.clearRect(0, 0, width, height);
                            ctx.drawImage(img, 0, 0, width, height);

                            canvas.toBlob((blob) => {
                                const sizeInMB = blob.size / (1024 * 1024);
                                if (sizeInMB <= this.Max_Size_MB) {
                                    finalBlob = blob;
                                    resolve(finalBlob);
                                } else {
                                    if (quality >= this.Min_Quality) {
                                        quality -= this.Quality_Step;
                                    } else {
                                        width = Math.round(width * this.Scale_Step);
                                        height = Math.round(height * this.Scale_Step);
                                        canvas.width = width;
                                        canvas.height = height;
                                    }
                                    resizeImage();
                                }
                            }, 'image/jpeg', quality);
                        };

                        resizeImage();
                    };
                };
                reader.readAsDataURL(image_file);
            } else {
                reject(new Error('No image file provided'));
            }
        });
    }

    uploadToImgBB(blob) {
        return new Promise((resolve, reject) => {
            if (!blob) {
                reject(new Error('No blob provided for upload'));
                return;
            }

            const formData = new FormData();
            formData.append('image', blob);

            fetch(`https://api.imgbb.com/1/upload?key=${this.imgbbApiKey}`, {
                method: 'POST',
                body: formData,
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.success) {
                        resolve(data.data.url);
                    } else {
                        reject(new Error('Failed to upload image to imgBB'));
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    resetItemError(item) {
        item.classList.remove('dl-error');
        item.classList.remove('dl-empty');
        item.classList.remove('dl-other-empty');
    }

    verifyItemRequired(item) {
        let result = true;
        if (item.dataset.dlRequired == 'true') {
            if (item.dataset.dlValue == '' || item.dataset.dlValue == null) {
                item.classList.remove('dl-error');
                item.classList.remove('dl-empty-error');
                item.classList.add('dl-empty');
                return false;
            } else {
                item.classList.remove('dl-empty');
            }
        }
        return result;
    }

    verifyForm() {
        let result = true;
        this.field_items.forEach((item) => {
            switch (item.dataset.dlType) {
                case 'email':
                    let email_value = item.querySelector('.dl-page-trade-in-h-body-form-item-value-input').value.trim();
                    item.dataset.dlValue = email_value;
                    const email_empty_veriry_result = this.verifyItemRequired(item);
                    result = email_empty_veriry_result && result;
                    if (email_empty_veriry_result) {
                        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                        const emailResult = emailRegex.test(email_value);
                        if (!emailResult) {
                            item.classList.remove('dl-empty');
                            item.classList.add('dl-error');
                            result = false;
                        } else {
                            item.classList.remove('dl-error');
                        }
                    }
                    break;
                case 'input':
                    let input_value = item.querySelector('.dl-page-trade-in-h-body-form-item-value-input').value?.trim();
                    item.dataset.dlValue = input_value;
                    result = this.verifyItemRequired(item) && result;
                    break;
                case 'image':
                    result = this.verifyItemRequired(item) && result;
                    break;
                case 'select':
                    let select_value = item.querySelector('.dl-page-trade-in-h-body-form-item-value-select-main').value?.trim();
                    item.dataset.dlValue = select_value;
                    const empty_veriry_result = this.verifyItemRequired(item);
                    result = empty_veriry_result && result;
                    if (empty_veriry_result) {
                        if (select_value == 'other') {
                            let other_input = item.querySelector('textarea');
                            if (other_input.value.trim() == '') {
                                item.dataset.dlValue = null;
                                item.classList.add('dl-other-empty');
                                item.classList.remove('dl-empty');
                                result = false;
                            } else {
                                item.dataset.dlValue = `other: ${other_input.value.trim()}`;
                                item.classList.remove('dl-other-empty');
                            }
                        } else {
                            item.dataset.dlValue = select_value;
                        }
                    }
                    break;
            }
        });
        return result;
    }

    formSubmit() {
        const trade_id = this.dataset.dlId;
        if (this.verifyForm()) {
            if (braze) {
                let amp_data = {};
                amp_data['trade_in_id'] = trade_id;
                let subdomain = window.location.hostname.split('.')[0];
                subdomain = subdomain == 'petlibro' || subdomain == 'ca' ? 'us' : subdomain;
                let braze_data = {};
                braze_data.trade_id = trade_id;
                const email_item = Array.from(this.field_items).find((item) => item.dataset.dlType === 'email');
                if (email_item && email_item.dataset.dlValue) {
                    DLPixelH.identify(email_item.dataset.dlValue);
                    braze_data.email = email_item.dataset.dlValue;
                    amp_data['trade_in_prop_email'] = email_item.dataset.dlValue;
                }
                DLPixelH.addToUserArrayProperty('trade-in-id', `trade-in-${subdomain}-${trade_id}`);
                try {
                    this.field_items.forEach((item) => {
                        switch (item.dataset.dlType) {
                            case 'email':
                                break;
                            default:
                                let key = `trade-in-${subdomain}-${trade_id}-${item.dataset.dlBrazeId}`;
                                DLPixelH.addToUserArrayProperty(key, item.dataset.dlValue);
                                braze_data[item.dataset.dlBrazeId] = item.dataset.dlValue;
                                amp_data[`trade_in_prop_${item.dataset.dlBrazeId}`] = item.dataset.dlValue;
                                break;
                        }
                    });
                    let trade_in_finished_time = new Date();
                    DLPixelH.setUserProperty(`trade-in-${trade_id}-finished-time`, trade_in_finished_time);
                    braze_data['finished-time'] = trade_in_finished_time;
                    braze_data['store'] = subdomain;
                    DLPixelH.capture('trade-in-submitted', braze_data);
                    localStorage.setItem(`trade-in-${trade_id}-submitted`, true);
                    this.showSubmitResult();
                    //amplitudeQueue.track('trade_in_submit', amp_data);
                } catch (error) {
                    DLPixelH.capture('trade-in-error', {
                        trade_id: trade_id,
                        error_message: error.message,
                        error_stack: error.stack,
                    });
                }
            }
        }
    }

    showSubmitResult() {
        this.main.classList.remove('dl-form');
        this.main.classList.add('dl-result');
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    showSubmitForm() {
        this.main.classList.add('dl-form');
        this.main.classList.remove('dl-result');
    }

    init() {
        let submitted = localStorage.getItem(`trade-in-${this.dataset.dlId}-submitted`);
        if (submitted) {
            this.showSubmitResult();
        } else {
            this.showSubmitForm();
        }
    }
}

customElements.define('dl-page-trade-in-h', DLPageTradeInH);
